module.exports = __webpack_public_path__ + "static/media/chests_silver.32685bf1.png";